import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { GECKO_CONSTS, GeckoModal } from '../../../ui';

import LiveChatChannelForm from './channel_forms/LiveChatChannelForm.jsx';
import FacebookChannelForm from './channel_forms/FacebookChannelForm.jsx';
import TwilioChannelForm from './channel_forms/TwilioChannelForm.jsx';
import TwitterChannelForm from './channel_forms/TwitterChannelForm.jsx';
import MailgunChannelForm from './channel_forms/MailgunChannelForm.jsx';
import WeChatChannelForm from './channel_forms/WeChatChannelForm.jsx';
import WhatsAppChannelForm from './channel_forms/WhatsAppChannelForm.jsx';

class ChannelEditModal extends Component {
  static propTypes = {
    channel: PropTypes.object,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      channel: props.channel,
    };
  }

  changeHandler(newVal) {
    // Keep internal state to stop re-renders
    this.setState({ channel: newVal });
    // Notify the parent of the changes
    this.props.onChange(newVal);
  }

  modalBodyContent() {
    switch (this.props.channel && this.props.channel.type) {
      case 'facebook':
      case 'instagram':
        return (
          <FacebookChannelForm
            value={this.state.channel}
            onChange={this.changeHandler.bind(this)}
          />
        );
      case 'live_chat':
        return (
          <LiveChatChannelForm
            value={this.state.channel}
            onChange={this.changeHandler.bind(this)}
            customFields={this.props.customFields}
          />
        );
      case 'twilio':
        return (
          <TwilioChannelForm
            value={this.state.channel}
            onChange={this.changeHandler.bind(this)}
          />
        );
      case 'twitter':
        return (
          <TwitterChannelForm
            value={this.state.channel}
            onChange={this.changeHandler.bind(this)}
          />
        );
      case 'mailgun':
        return (
          <MailgunChannelForm
            value={this.state.channel}
            onChange={this.changeHandler.bind(this)}
          />
        );
      case 'wechat':
        return (
          <WeChatChannelForm
            value={this.state.channel}
            onChange={this.changeHandler.bind(this)}
          />
        );
      case 'whatsapp':
        return (
          <WhatsAppChannelForm
            value={this.state.channel}
            onChange={this.changeHandler.bind(this)}
          />
        );
      default:
        return null;
    }
  }

  modalButtons() {
    const channelType = (channel) => channel?.type;
    const channel = this.state.channel;
    const fbChannel = channelType(channel) === 'facebook';
    const instaChannel = channelType(channel) === 'instagram';
    const twilioChanel = channelType(channel) === 'twilio';
    return [
      {
        preset: GECKO_CONSTS.BTN_PRESET_SAVE,
        disabledWhen: () => {
          if (twilioChanel) {
            if (
              !channel.configuration.phone_number &&
              !channel.configuration.twilio_number
            ) {
              return true;
            }
            return false;
          }
        },
        hideWhen: () => {
          return (
            (fbChannel || instaChannel) && !this.state.channel?.name.length
          );
        },
        handler: () => {
          return this.props.onSave();
        },
      },
    ];
  }

  modalHeaderContent() {
    switch (this.props.channel && this.props.channel.type) {
      case 'facebook':
        return 'Facebook Channel Details';
      case 'instagram':
        return 'Instagram Channel Details';
      case 'live_chat':
        return 'Live Chat Channel Details';
      case 'twilio':
        return 'SMS Channel Details';
      case 'twitter':
        return 'Twitter Channel Details';
      case 'mailgun':
        return 'Email Channel Details';
      case 'wechat':
        return 'WeChat Channel Details';
      case 'whatsapp':
        return 'WhatsApp Channel Details';
      default:
        return 'Channel Details';
    }
  }

  render() {
    return (
      <GeckoModal
        name={this.modalHeaderContent()}
        fields={[]}
        values={{}}
        handler={this.props.onChange}
        btns={this.modalButtons()}
      >
        {this.modalBodyContent()}
      </GeckoModal>
    );
  }
}

export default ChannelEditModal;
